export const STATUS = [
  { text: "通常", value: 1 },
  { text: "早期終了", value: 2 },
];
